import Marionette from 'backbone.marionette';
import { OffSeasonView } from '../../views';

import { redirectTo } from '../../utils';
import HelpController from '../Help';
import FantasyController from '../Fantasy';
import StatsController from "../Stats";
import MatchCentreController from "../MatchCentre";

export default class OffSeasonController extends Marionette.Object {

	redirectToOffSeason() {
		redirectTo('off-season-2024');
	}

	prizes() {
		const Help = new HelpController({
			rootView: this.getOption('rootView')
		});
		Help.prizes();
	}

	rankings() {
		const Fantasy = new FantasyController({
			rootView: this.getOption('rootView')
		});
		Fantasy.rankings();
	}

	statsCentre() {
		const Stats = new StatsController({
			rootView: this.getOption('rootView')
		});
		Stats.statsCentre();
	}

	playerProfile(player_id) {

		const Stats = new StatsController({
			rootView: this.getOption('rootView')
		});
		Stats.playerProfile(player_id);
	}

	matchCentreLanding(round_id) {
		const MatchCentre = new MatchCentreController({
			rootView: this.getOption('rootView')
		});
		MatchCentre.matchCentreLanding(round_id);
	}

	matchCentre(round_id, match_id) {
		const MatchCentre = new MatchCentreController({
			rootView: this.getOption('rootView')
		});
		MatchCentre.matchCentre(round_id, match_id);
	}

	/**
	 * Method for Off Season Page
	 */
	offSeasonPage() {
		this.getOption('rootView')
			.getRegion('main')
			.show(new OffSeasonView());
	}
}